// @ts-ignore
import {HttpClient} from '@angular/common/http';
// @ts-ignore
import {Injectable} from '@angular/core';
// @ts-ignore
import {Observable, forkJoin} from 'rxjs';
import {map} from 'rxjs/operators';

export interface DemonstrativoFinalizacaoVendaResultado {
    nunota: number;
    sucesso: boolean;
    mensagem?: string;
    erro?: string;
    codigoErro?: string;
    nivelErro?: string;
    retornoNativo?: Record<string, any>;
}

export interface DemonstrativoFinalizacaoVendaResponse {
    sucesso: boolean;
    erro?: string;
    resultado: DemonstrativoFinalizacaoVendaResultado[];
}

export interface DemonstrativoAjusteItemNativo {
    nunota: number;
    sequencia: number;
    codProd: number;
    partnumber: string;
    produto: string;
    codVol: string;
    qtd: number;

    vlrUnitReal: number;
    vlrUnitMoeda: number;

    vlrTotalReal: number;
    vlrTotalMoeda: number;

    percDesc: number;

    vlrDescReal: number;
    vlrDescMoeda: number;

    vlrTotalLiqReal: number;
    vlrTotalLiqMoeda: number;

    vlrIpiReal?: number;
    vlrStReal?: number;

    /*
     * Valor unitário líquido retornado pelo
     * CACSP.calculaValoresItemNota.
     */
    vlrUnitLiqReal?: number;
    vlrUnitLiqMoeda?: number;

    itemNativo: Record<string, string>;
}

export interface DemonstrativoAjusteNotaNativo {
    nunota: number;
    numNota?: number;

    emissao: string;
    status: string;
    statusNota?: string;

    sucesso: boolean;
    erro?: string;

    valorNotaReal: number;

    cotacao: number;
    codMoeda: number;

    totalBrutoItensReal: number;
    descontoReal: number;
    totalLiquidoItensReal: number;

    totalBrutoItensMoeda: number;
    descontoMoeda: number;
    totalLiquidoItensMoeda: number;

    totalIpiReal?: number;
    totalStReal?: number;

    percentualDesconto: number;

    vlrDescTotItemCabecalho?: number;
    vlrDescTotItemMoedaCabecalho?: number;

    itens: DemonstrativoAjusteItemNativo[];
}

export interface DemonstrativoAjustesNativosResponse {
    sucesso: boolean;
    notas: DemonstrativoAjusteNotaNativo[];
}

export interface DemonstrativoCalculoAjusteNativoResponse {
    sucesso: boolean;

    nunota: number;
    sequencia: number;

    percDesc: number;

    vlrDescReal: number;
    vlrDescMoeda: number;

    vlrTotalLiqReal: number;
    vlrTotalLiqMoeda: number;

    vlrUnitLiqReal: number;
    vlrUnitLiqMoeda: number;

    itemNativo: Record<string, string>;
}

export interface DemonstrativoSalvarAjustesNativosResponse {
    sucesso: boolean;

    resultado: Array<{
        nunota: number;
        sequencia: number;
        sucesso: boolean;
        erro?: string;
    }>;
}

export interface CotacaoPayload {
    CODPROD: string;
    FORNEC: string;
    PRECO: string;
    VARIACAO: string;
    CORE: string;
    LUCRO: string;
    CUSTO: string;
    PRECOVENDA: string;
    REFFORN: string;
    DESCRPROD: string;
    CODVOL: string;
    TEMSERIE: string;
    TEMCORE: string;
    MARCA: string;
    CONDICAO: string;
    OBSTECNICA: string;
    OBSINTERNA: string;
}

export interface SankhyaEnvelope<T = unknown> {
    serviceName?: string;
    status?: string;
    statusMessage?: string;
    responseBody?: T;
}

export interface DemonstrativoCliente {
    codparc?: string | number;
    codparcs?: Array<string | number>;
    nomeparc: string;
    codaero?: string | number;
    prefixo?: string;
    docparc?: string;
    endereco?: string;
    inscEstadual?: string;
    numero?: string;
    complemento?: string;
    bairro?: string;
    cidade?: string;
    uf?: string;
    cep?: string;
    tipoBusca?: 'CLIENTE' | 'VENDEDOR' | 'PREFIXO';
}

export interface DemonstrativoDados {
    parceiro?: {
        nomeParc?: string;
        docNumero?: string;
        tipPessoa?: string;
    };
    usuario?: {
        NOMEUSU?: string;
        CODUSU?: string;
    };
    itens?: Array<Record<string, unknown>>;
    contas?: Array<Record<string, unknown>>;
    totNotas?: number;
    sucesso?: boolean;
    erro?: string;
}

export interface DemonstrativoCotacao {
    codigoMoeda?: number;
    moeda?: string;

    valor: string | number;

    data?: string;
    DATA?: string;
    DATA_BR?: string;
    DTMOV?: string;

    [key: string]: unknown;
}

export interface DemonstrativoCotacoesResponse {
    sucesso: boolean;
    total?: number;
    erro?: string;
    cotacoes: DemonstrativoCotacao[];
}

export interface DemonstrativoAtualizacaoResponse {
    sucesso?: boolean;
    autorizado?: boolean;
    erro?: string;
    mensagem?: string;
    mensagemSolicitacao?: string;
    excedeLimite?: boolean;
    cotacaoAtualizada?: boolean;
    notasAtualizadas?: number;
    solicitacaoSalva?: boolean;
    solicitacoesCriadas?: number;
    solicitacoesExistentes?: number;
}

export interface DemonstrativoPrefixo {
    codaero: string | number;
    prefixo: string;
    codparc?: string | number;

    [key: string]: unknown;
}

export interface DemonstrativoPrefixosResponse {
    sucesso?: boolean;
    erro?: string;
    conPrefixo?: number;
    prefixos?: DemonstrativoPrefixo[];
}

export interface SankhyaAmbienteResponse {
    environment: string;
    baseUrl: string;
}

export interface DemonstrativoAlteracaoClientePrefixoResponse {
    sucesso: boolean;
    mensagem?: string;
    erro?: string;

    resultado?: Array<{
        nunota: number;
        sucesso: boolean;
        erro?: string;
    }>;
}

export interface DemonstrativoAlteracaoFormaPagamentoResponse {
    sucesso: boolean;
    mensagem?: string;
    erro?: string;

    resultado?: Array<{
        nunota: number;
        sucesso: boolean;
        erro?: string;
    }>;
}

/*
 * Estruturas anteriores preservadas.
 *
 * Não são removidas porque podem existir outras telas
 * utilizando esses contratos.
 */
export interface DemonstrativoAjusteNativoItem {
    nunota: number;
    sequencia: number;
    codProd: number;

    partnumber: string;
    produto: string;
    codVol: string;

    qtd: number;

    vlrUnitReal: number;

    vlrTotalReal: number;
    vlrTotalMoeda: number;

    percDesc: number;

    vlrDescReal: number;
    vlrDescMoeda: number;

    vlrTotalLiqReal: number;
    vlrTotalLiqMoeda: number;

    vlrUnitLiqReal: number;
    vlrUnitMoeda: number;
    vlrUnitLiqMoeda: number;

    vlrAcrescDesc: number;
}

export interface DemonstrativoAjusteNativoNota {
    nunota: number;
    numNota?: number;

    emissao: string;
    status: string;

    sucesso: boolean;
    erro?: string;

    valorNotaReal: number;

    cotacao: number;
    codMoeda: number;

    totalBrutoItensReal: number;
    totalBrutoItensMoeda: number;

    descontoReal: number;
    descontoMoeda: number;

    percentualDesconto: number;

    itens: DemonstrativoAjusteNativoItem[];
}

// @ts-ignore
@Injectable({providedIn: 'root'})
export class SankhyaGatewayService {

    private readonly apiUrl = '/api/sankhya';

    constructor(
        private readonly http: HttpClient
    ) {
    }

    buscarAmbienteSankhya(): Observable<SankhyaAmbienteResponse> {
        return this.http.get<SankhyaAmbienteResponse>(
            `${this.apiUrl}/ambiente`
        );
    }

    /**
     * Realiza login no sistema
     */
    login(): Observable<unknown> {
        return this.http.post(
            `${this.apiUrl}/login`,
            {}
        );
    }

    sincronizarEdicaoAerosys(
        payload: Record<string, string>
    ): Observable<unknown> {
        return this.http.post(
            '/api/produto-aerosys/sincronizar-edicao',
            payload
        );
    }

    /**
     * Traz os dados de estoque do Aerosys para um produto, usado para recuperar
     * campos que só existem lá, como o "Local" em formato string ("1-A-1").
     */
    buscarEstoqueAerosys(
        codprod: number | string,
        codEmpSankhya?: number
    ): Observable<{ local?: string; estoqueAtual?: number; [key: string]: any }> {
        return this.http.get<{ local?: string; estoqueAtual?: number; [key: string]: any }>(
            `/api/produto-aerosys/${codprod}/estoque`,
            codEmpSankhya ? { params: { codEmpSankhya } } : {}
        );
    }

    /**
     * Salva uma imagem (base64) no Sankhya (via Serviço mge) e
     * grava no Aerosys (via API Node legado).
     */
    salvarImagemProduto(
        payload: Record<string, unknown>
    ): Observable<unknown> {
        return this.http.post(
            '/api/produto-aerosys/imagem',
            payload
        );
    }

    /**
     * Reliza logout no sistema
     */
    logout(): Observable<unknown> {
        return this.http.post(
            `${this.apiUrl}/logout`,
            {}
        );
    }

    /**
     * Lista as últimas cotações efetuadas no produto
     * @param codprod
     */
    listarCotacaoProduto(
        codprod: string
    ): Observable<unknown> {

        return this.http.get(
            `${this.apiUrl}/cotacoes/${encodeURIComponent(codprod)}`
        );
    }

    /**
     * Salva uma nova cotação para um produto e salva alterações no produto caso exista alteração
     * @param payload
     */
    salvarCotacao(
        payload: CotacaoPayload
    ): Observable<unknown> {

        return this.http.post(
            `${this.apiUrl}/cotacoes`,
            payload
        );
    }

    buscarClientesDemonstrativo(
        cliente: string
    ): Observable<
        SankhyaEnvelope<{
            lista: DemonstrativoCliente[];
            sucesso: boolean;
            erro?: string;
        }>
    > {

        return this.http.post<
            SankhyaEnvelope<{
                lista: DemonstrativoCliente[];
                sucesso: boolean;
                erro?: string;
            }>
        >(
            `${this.apiUrl}/demonstrativo/clientes`,
            {
                CLIENTE: cliente
            }
        );
    }

    buscarDadosDemonstrativo(
        payload: {
            CODPARC?: string | number;
            CODVEND?: string | number;
            DTINICIAL: string;
            DTFINAL: string;
            TIPO_BUSCA?: 'CLIENTE' | 'VENDEDOR';
        }
    ): Observable<SankhyaEnvelope<DemonstrativoDados>> {

        return this.http.post<
            SankhyaEnvelope<DemonstrativoDados>
        >(
            `${this.apiUrl}/demonstrativo/dados`,
            payload
        );
    }

    buscarPrefixosGlobalDemonstrativo(
        termo: string
    ): Observable<
        SankhyaEnvelope<DemonstrativoPrefixosResponse>
    > {

        return this.http.post<
            SankhyaEnvelope<DemonstrativoPrefixosResponse>
        >(
            `${this.apiUrl}/demonstrativo/prefixos/busca`,
            {
                TERMO: termo
            }
        );
    }

    buscarVendasPorCodaeroDemonstrativo(
        payload: {
            PREFIXO: string;
            TIPO_BUSCA: 'PREFIXO';
            DTINICIAL: string;
            DTFINAL: string;
        }
    ): Observable<SankhyaEnvelope<DemonstrativoDados>> {

        return this.http.post<
            SankhyaEnvelope<DemonstrativoDados>
        >(
            `${this.apiUrl}/demonstrativo/prefixo/vendas`,
            payload
        );
    }

    atualizarCotacaoVenda(
        payload: {
            cotacao: number;
            notas: number[];
        }
    ): Observable<
        SankhyaEnvelope<DemonstrativoAtualizacaoResponse>
    > {

        return this.http.post<
            SankhyaEnvelope<DemonstrativoAtualizacaoResponse>
        >(
            `${this.apiUrl}/demonstrativo/cotacao-venda`,
            payload
        );
    }

    solicitarLiberacaoCotacao(
        payload: {
            cotacao: number;
            notas: number[];
        }
    ): Observable<
        SankhyaEnvelope<DemonstrativoAtualizacaoResponse>
    > {

        return this.http.post<
            SankhyaEnvelope<DemonstrativoAtualizacaoResponse>
        >(
            `${this.apiUrl}/demonstrativo/cotacao-liberacao`,
            payload
        );
    }

    buscarPrefixosDemonstrativo(
        payload: {
            CNPJ: string;
        }
    ): Observable<
        SankhyaEnvelope<DemonstrativoPrefixosResponse>
    > {

        return this.http.post<
            SankhyaEnvelope<DemonstrativoPrefixosResponse>
        >(
            `${this.apiUrl}/demonstrativo/prefixos`,
            payload
        );
    }

    atualizarPrefixoDemonstrativo(
        payload: {
            CODAERO: number;
            notas: number[];
        }
    ): Observable<
        SankhyaEnvelope<DemonstrativoAtualizacaoResponse>
    > {

        return this.http.post<
            SankhyaEnvelope<DemonstrativoAtualizacaoResponse>
        >(
            `${this.apiUrl}/demonstrativo/prefixo`,
            payload
        );
    }

    salvarAjustesNativosDemonstrativo(
        payload: {
            ajusteTipo: 'DES' | 'ACR';
            itens: Array<Record<string, unknown>>;
        }
    ): Observable<unknown> {

        return this.http.post(
            `${this.apiUrl}/demonstrativo/ajustes-nativos`,
            payload
        );
    }

    traduzirPtParaEn(
        texto: string
    ): Observable<{
        traducao: string;
        sucesso: boolean;
    }> {

        return this.http.post<{
            traducao: string;
            sucesso: boolean;
        }>(
            `${this.apiUrl}/traducao/pt-en`,
            {
                texto
            }
        );
    }

    proxy(
        module: 'mge' | 'mgecom' | 'gpl' | 'upload-anexo',
        serviceName: string,
        requestBody: unknown
    ): Observable<unknown> {

        return this.http.post(
            `${this.apiUrl}/proxy`,
            {
                module,
                serviceName,
                requestBody
            }
        );
    }

    buscarControleCoreNativo(): Observable<unknown> {
        return this.http.post(`${this.apiUrl}/controle-core/buscar`, {});
    }

    buscarControleFormsNativo(): Observable<unknown> {
        return this.http.post(`${this.apiUrl}/controle-forms/buscar`, {});
    }

    buscarMovimentacoesControleFormsNativo(nuform: number): Observable<unknown> {
        return this.http.post(`${this.apiUrl}/controle-forms/movimentacoes`, { nuform });
    }

    buscarFabricantesNativo(): Observable<unknown> {
        return this.http.post(`${this.apiUrl}/fabricantes/buscar`, {});
    }

    salvarFabricanteNativo(payload: { codigo: number; descricao?: string; margemLucro?: string; margemCusto?: string; prazoAtualizacao?: string; origem?: string }): Observable<unknown> {
        return this.http.post(`${this.apiUrl}/fabricantes/salvar`, payload);
    }

    criarFabricanteNativo(payload: { descricao: string; margemLucro: string; margemCusto: string; prazoAtualizacao: string; origem: string }): Observable<unknown> {
        return this.http.post(`${this.apiUrl}/fabricantes/criar`, payload);
    }

    excluirFabricanteNativo(codigo: number): Observable<unknown> {
        return this.http.post(`${this.apiUrl}/fabricantes/excluir`, { codigo });
    }

    buscarContasNativo(): Observable<unknown> {
        return this.http.post(`${this.apiUrl}/contas/buscar`, {});
    }

    buscarDetalheContaNativo(codigoInterno: string): Observable<unknown> {
        return this.http.post(`${this.apiUrl}/contas/detalhe`, { codigoInterno });
    }

    buscarCategoriasExtratoContaNativo(codigoInterno: string): Observable<unknown> {
        return this.http.post(`${this.apiUrl}/contas/categorias-extrato`, { codigoInterno });
    }

    buscarFaixasCepContaNativo(codigoInterno: string): Observable<unknown> {
        return this.http.post(`${this.apiUrl}/contas/faixas-cep`, { codigoInterno });
    }

    salvarContaNativo(payload: Record<string, unknown>): Observable<unknown> {
        return this.http.post(`${this.apiUrl}/contas/salvar`, payload);
    }

    /** Locais de estoque do produto (Sankhya) + data da última entrada, p/ o seletor "Local" dos itens de compra. */
    buscarLocaisParaItem(codProd: number, codEmp: number, codLocal?: number): Observable<unknown> {
        return this.chamarServiceGpl('EstoqueGlobalSP.doBuscarLocaisParaItem', { CODPROD: codProd, CODEMP: codEmp, ...(codLocal ? { CODLOCAL: codLocal } : {}) });
    }

    chamarServiceGpl(
        serviceName: string,
        requestBody: unknown
    ): Observable<unknown> {

        return this.http.post(
            `${this.apiUrl}/services/${serviceName}`,
            {
                requestBody
            }
        );
    }

    consultarOrcamentoImpressao(
        requestBody: unknown
    ): Observable<unknown> {

        return this.http.post(
            `${this.apiUrl}/venda-impressao/consultar`,
            requestBody
        );
    }

    consultarCompraImpressao(
        requestBody: { nunota: number; modelo: string }
    ): Observable<unknown> {
        return this.http.post(
            `${this.apiUrl}/compra-impressao/consultar`,
            requestBody
        );
    }

    buscarClientesImpressao(
        requestBody: unknown
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'ParceiroGlobalSP.doBuscarCliente',
            requestBody
        );
    }

    buscarClientesAlteracaoVenda(
        requestBody: unknown
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'ParceiroGlobalSP.doBuscarCliente',
            {
                ...(requestBody as Record<string, unknown>),
                SEM_AGRUPAR: 'S',
                USO: 'ALTERAR_CLIENTE_VENDA'
            }
        );
    }

    buscarVendasImpressao(
        requestBody: unknown
    ): Observable<unknown> {

        return this.http.post(
            `${this.apiUrl}/venda-impressao/buscar-vendas`,
            requestBody
        );
    }

    gerarQrCodeImpressao(
        requestBody: unknown
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'QrCodeGlobalSP.doGerarQrCode',
            requestBody
        );
    }

    produtosCotacaoEdicao(): Observable<unknown> {

        return this.chamarServiceGpl(
            'ProdutoGlobalSP.doProdutosCotacao',
            {}
        );
    }

    buscarProdutosEdicao(
        requestBody: unknown
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'ProdutoGlobalSP.doBuscarProdutos',
            requestBody
        );
    }

    buscarPecasModal(
        params: {
            REFFORN?: string;
            DESCRICAO?: string;
            MARCA?: string;
            CODEMP?: number;
        }
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'ProdutoGlobalSP.doBuscarProdutos',
            params
        ).pipe(map((res: any) => {
            // O PN pesquisado sempre vem primeiro (igual > começa com > resto), em todas as telas de Busca de Peças.
            const termo = (params.REFFORN ?? params.DESCRICAO ?? '').toString();
            const lista: any[] | undefined = (res?.responseBody ?? res)?.lista;
            if (Array.isArray(lista) && termo.trim()) {
                const limpar = (s: unknown) => String(s ?? '').toUpperCase().replace(/[^A-Z0-9]/g, '');
                const t = limpar(termo);
                if (t) {
                    const peso = (p: any) => {
                        const pn = limpar(p?.refforn ?? p?.referencia);
                        return pn === t ? 0 : (pn.startsWith(t) ? 1 : 2);
                    };
                    const ordenada = lista
                        .map((p, i) => ({ p, i, w: peso(p) }))
                        .sort((a, b) => a.w - b.w || a.i - b.i)
                        .map(x => x.p);
                    lista.splice(0, lista.length, ...ordenada);
                }
            }
            return res;
        }));
    }

    buscarAlternativosProduto(
        codprod: number,
        codemp?: number
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'ProdutoGlobalSP.doBuscarAlternativos',
            {
                codprod,
                codemp
            }
        );
    }

    atualizarCotacaoVendaNativa(
        payload: {
            cotacao: number;
            notas: number[];
        }
    ): Observable<
        SankhyaEnvelope<DemonstrativoAtualizacaoResponse>
    > {

        return this.http.post<
            SankhyaEnvelope<DemonstrativoAtualizacaoResponse>
        >(
            `${this.apiUrl}/demonstrativo/cotacao-venda-nativa`,
            payload
        );
    }

    carregarProdutosAlternativosNativos(codprod: string | number): Observable<unknown> {
        return this.http.get(`${this.apiUrl}/produto/${codprod}/alternativos`);
    }

    pesquisarProdutosAlternativosNativos(
        codprod: string | number,
        termo: string,
        codMarca: string = ''
    ): Observable<unknown> {
        return this.http.get(`${this.apiUrl}/produto/alternativos/pesquisar`, {
            params: {codprod: String(codprod), termo: termo || '', codMarca: codMarca || ''}
        });
    }

    salvarProdutosAlternativosNativos(codprod: string | number, produtos: any[]): Observable<unknown> {
        return this.http.post(`${this.apiUrl}/produto/${codprod}/alternativos`, {produtos});
    }

    excluirProdutoAlternativoNativo(codprod: string | number, codprodalt: string | number): Observable<unknown> {
        return this.http.delete(`${this.apiUrl}/produto/${codprod}/alternativos/${codprodalt}`);
    }

    produtoSelecionadoEdicao(
        requestBody: unknown
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'ProdutoGlobalSP.doProdutoSelecionado',
            requestBody
        );
    }

    cotacoesProdutoEdicao(
        requestBody: unknown
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'ProdutoGlobalSP.doCotacoesProduto',
            requestBody
        );
    }

    salvarCotacaoProdutoEdicao(
        requestBody: unknown
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'ProdutoGlobalSP.doSalvaCotacaoProduto',
            requestBody
        );
    }

    buscarFabricantesEdicao(
        requestBody: unknown
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'FabricanteGlobalSP.doBuscarFabricantes',
            requestBody
        );
    }

    buscarVolumesEdicao(
        requestBody: unknown
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'VolumeGlobalSP.doBuscarVolumes',
            requestBody
        );
    }

    buscarFornecedoresEdicao(
        requestBody: unknown
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'ParceiroGlobalSP.doBuscarFornecedores',
            requestBody
        );
    }

    buscarImgProdutoEdicao(
        requestBody: unknown
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'ProdutoGlobalSP.doBuscarImg',
            requestBody
        );
    }

    salvarImgProdutoEdicao(
        requestBody: unknown
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'ProdutoGlobalSP.doSalvarImg',
            requestBody
        );
    }

    deletarImgProdutoEdicao(
        requestBody: unknown
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'ProdutoGlobalSP.doDeletarImg',
            requestBody
        );
    }

    consultarComissoesVendedores(
        requestBody: unknown
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'ComissaoGlobalSP.doProcessarCalculoComissao',
            requestBody
        );
    }

    consultarComissionamento(
        requestBody: unknown
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'ComissaoGlobalSP.doProcessarCalculoComissionamento',
            requestBody
        );
    }

    /*
     * PEDIDO DE VENDA
     */

    buscarClientePedidoVenda(
        termo: string
    ): Observable<
        SankhyaEnvelope<{
            lista: DemonstrativoCliente[];
            sucesso: boolean;
            erro?: string;
        }>
    > {

        return this.http.post<
            SankhyaEnvelope<{
                lista: DemonstrativoCliente[];
                sucesso: boolean;
                erro?: string;
            }>
        >(
            `${this.apiUrl}/demonstrativo/clientes`,
            {
                CLIENTE: termo,
                TIPO: 'CLIENTE'
            }
        );
    }

    buscarFornecedorPedidoCompra(
        termo: string
    ): Observable<
        SankhyaEnvelope<{
            lista: DemonstrativoCliente[];
            sucesso: boolean;
            erro?: string;
        }>
    > {

        return this.http.post<
            SankhyaEnvelope<{
                lista: DemonstrativoCliente[];
                sucesso: boolean;
                erro?: string;
            }>
        >(
            `${this.apiUrl}/demonstrativo/clientes`,
            {
                CLIENTE: termo,
                TIPO: 'FORNECEDOR'
            }
        );
    }

    buscarTransportadoraPedidoVenda(
        termo: string
    ): Observable<
        SankhyaEnvelope<{
            lista: DemonstrativoCliente[];
            sucesso: boolean;
            erro?: string;
        }>
    > {

        return this.http.post<
            SankhyaEnvelope<{
                lista: DemonstrativoCliente[];
                sucesso: boolean;
                erro?: string;
            }>
        >(
            `${this.apiUrl}/demonstrativo/clientes`,
            {
                CLIENTE: termo,
                TIPO: 'TRANSPORTADORA'
            }
        );
    }

    buscarEnderecoClientePedidoVenda(
        codparc: string | number
    ): Observable<unknown> {

        return this.http.post(
            `${this.apiUrl}/parceiro/endereco-cliente`,
            {
                CODPARC: codparc
            }
        );
    }

    buscarTiposOperacaoPedidoVenda(): Observable<unknown> {
        return this.chamarServiceGpl(
            'TipoOperacaoComponentSP.doBuscarTiposOperacao',
            {}
        );
    }

    /**
     * Busca a descrição (DESCROPER) de UMA TOP fixa específica, direto do
     * TGFTOP -- usado nas telas com TOP fixa (Pedido de Compra, Pré-Compra)
     * pra mostrar o nome real da TOP em vez de texto fixo no front.
     */
    buscarDescricaoTop(codTipOper: number): Observable<unknown> {
        return this.chamarServiceGpl(
            'TipoOperacaoComponentSP.doBuscarDescricaoTop',
            { codTipOper }
        );
    }

    /**
     * Anexos de documentos por venda (GPL_ANEXO_VENDA) — mecanismo PRÓPRIO do
     * addon (BLOB numa tabela nossa), independente do "clipe" nativo do
     * Sankhya (que não é compatível com Cabeçalho de Nota) e independente da
     * tela nativa, já que a tela de vendas do GPL-Integracao é externa/custom.
     */
    anexarArquivoVenda(nunota: number, nomeArquivo: string, conteudoBase64: string, descricao: string = ''): Observable<unknown> {
        return this.chamarServiceGpl('PedidoVendaGlobalSP.doAnexarArquivoVenda', {
            nunota, nomeArquivo, conteudoBase64, descricao
        });
    }

    listarAnexosVenda(nunota: number): Observable<unknown> {
        return this.chamarServiceGpl('PedidoVendaGlobalSP.doListarAnexosVenda', {nunota});
    }

    baixarAnexoVenda(nuanexo: number): Observable<unknown> {
        return this.chamarServiceGpl('PedidoVendaGlobalSP.doBaixarAnexoVenda', {nuanexo});
    }

    excluirAnexoVenda(nuanexo: number): Observable<unknown> {
        return this.chamarServiceGpl('PedidoVendaGlobalSP.doExcluirAnexoVenda', {nuanexo});
    }

    buscarVendedorLogadoPedidoVenda(): Observable<unknown> {
        return this.http.post(
            `${this.apiUrl}/parceiro/vendedor-logado`,
            {}
        );
    }

    buscarVendedoresPedidoVenda(
        payload = {}
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'VendedorGlobalSP.doBuscarVendedores',
            payload
        );
    }

    buscarTiposNegociacaoPedidoVenda(): Observable<unknown> {
        return this.chamarServiceGpl(
            'TipoNegociacaoComponentSP.doBuscarTiposVenda',
            {}
        );
    }

    buscarCentrosResultadoPedidoVenda(): Observable<unknown> {
        return this.chamarServiceGpl(
            'CentroResultadoComponentSP.doBuscarCentrosResultado',
            {}
        );
    }

    buscarProjetosPedidoVenda(): Observable<unknown> {
        return this.chamarServiceGpl(
            'ProjetoComponentSP.doBuscarProjetos',
            {}
        );
    }

    buscarNaturezasPedidoVenda(): Observable<unknown> {
        return this.chamarServiceGpl(
            'NaturezaComponentSP.doBuscarNaturezas',
            {}
        );
    }

    buscarEmpresasPedidoVenda(): Observable<unknown> {
        return this.chamarServiceGpl(
            'EmpresaComponentSP.doBuscarEmpresas',
            {}
        );
    }

    buscarStatusFinanceiroPedidoVenda(
        codparc: string | number
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'ParceiroGlobalSP.doBuscarStatusFinanceiro',
            {
                CODPARC: codparc
            }
        );
    }

    buscarAeronavesPedidoVenda(
        codparc: string | number
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'AeronaveGlobalSP.doBuscarPrefixosPorCliente',
            {
                CODPARC: codparc
            }
        );
    }

    buscarAeronavesEClientesGlobal(
        termo: string
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'AeronaveGlobalSP.doBuscarAeronaveEClienteGlobal',
            {
                TERMO: termo
            }
        );
    }

    /** Aeronaves do Aerosys (com proprietarios) -- comparacao com o cadastro do Sankhya. */
    listarAeronavesAerosys(): Observable<any> {
        return this.http.get<any>('/api/aeronave/aerosys');
    }

    /** Espelha a aeronave do cadastro no Aerosys (AERONAVE + AERO_PESSOA). Best-effort -- ver AeronaveAerosysComponent. */
    espelharAeronaveAerosys(payload: any): Observable<any> {
        return this.http.post<any>('/api/aeronave/espelhar-aerosys', payload);
    }

    buscarAeronavePorCodigo(
        codaero: string | number
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'AeronaveGlobalSP.doBuscarAeronavePorCodigo',
            {
                CODAERO: codaero
            }
        );
    }

    buscarEnderecosPorCnpjPedidoVenda(
        cnpj: string
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'ParceiroGlobalSP.doBuscarEnderecosPorCnpj',
            {
                CNPJ: cnpj
            }
        );
    }

    buscarOpcoesCampoPedidoVenda(
        nomeTabela: string,
        nomeCampo: string
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'CampoOpcoesComponentSP.doBuscarOpcoes',
            {
                NOMETAB: nomeTabela,
                NOMECAMPO: nomeCampo
            }
        );
    }

    gravarPedidoVenda(
        requestBody: unknown
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'PedidoVendaGlobalSP.doGravarPedido',
            requestBody
        );
    }

    /** Valida/corrige os itens (volume, local, quantidade, produto inativo) antes de gravar uma EDIÇÃO de Pedido de Compra. */
    validarItensPedidoCompra(
        requestBody: unknown
    ): Observable<any> {

        return this.http.post<any>(
            '/api/pedido-compra/validar-itens',
            {
                requestBody
            }
        );
    }

    /**
     * Grava um Pedido de Compra NOVO nos dois sistemas: Sankhya (mesmo
     * serviço nativo de sempre, PedidoVendaGlobalSP.doGravarPedido) e,
     * best-effort, um PEDIDO_COMPRA espelho no Aerosys. Diferente de
     * gravarPedidoVenda(), não passa pelo proxy genérico /api/sankhya —
     * chama um endpoint dedicado do GPL-Integracao que orquestra os dois
     * sistemas (ver PedidoCompraController/PedidoCompraComponent no
     * backend). Usar SÓ na criação (não na edição) do Pedido de Compra —
     * ver pedido-compra-form.component.ts.
     */
    gravarPedidoCompra(
        requestBody: unknown
    ): Observable<unknown> {

        return this.http.post(
            '/api/pedido-compra/gravar',
            {
                requestBody
            }
        );
    }

    /**
     * "Funções > Importar Pedidos de Compra" (Pré-Compra e Pedido de Compra)
     * — lista combinada dos Pedidos de Compra nativos do Sankhya (TOP 1300)
     * e do Aerosys, já deduplicada via GPL_PCRIDAEROSYS (um pedido gravado
     * nos dois sistemas aparece como UMA linha, origem "AMBOS"). Ver
     * PedidoCompraController#listarPedidosCombinados no backend.
     */
    buscarPedidosCompraCombinados(
        codEmp: number
    ): Observable<unknown> {

        return this.http.get(
            '/api/pedido-compra/combinados/listar',
            {
                params: { codEmp }
            }
        );
    }

    /**
     * Itens dos Pedidos de Compra selecionados na função "Importar Pedidos
     * de Compra" — recebe as linhas combinadas escolhidas pelo usuário
     * (mesmo shape devolvido por buscarPedidosCompraCombinados) e devolve os
     * itens de cada lado, marcados com origemItem ("SANKHYA"/"AEROSYS") e
     * headerId (NUNOTA ou PCR_ID), pra tela mostrar de qual pedido/sistema
     * cada item veio. Ver PedidoCompraController#listarItensPedidosSelecionados.
     */
    buscarItensPedidosCompraSelecionados(
        pedidosSelecionados: unknown[]
    ): Observable<unknown> {

        return this.http.post(
            '/api/pedido-compra/combinados/itens',
            pedidosSelecionados
        );
    }

    /**
     * Grava uma Pré-Compra NOVA (TOP 1301) nos dois sistemas: Sankhya (mesmo
     * serviço nativo, PedidoVendaGlobalSP.doGravarPedido) e, best-effort, um
     * PRECOMPRA espelho no Aerosys. Mesmo desenho de gravarPedidoCompra() --
     * ver PreCompraController/PreCompraComponent no backend. Usar SÓ na
     * criação (não na edição) da Pré-Compra -- ver pre-compra-form.component.ts.
     */
    gravarPreCompra(
        requestBody: unknown
    ): Observable<unknown> {

        return this.http.post(
            '/api/pre-compra/gravar',
            {
                requestBody
            }
        );
    }

    /**
     * Grava uma Compra NOVA nos dois sistemas: Sankhya (mesmo serviço
     * nativo, PedidoVendaGlobalSP.doGravarPedido) e, best-effort, um COMPRA
     * espelho no Aerosys. Mesmo desenho de gravarPreCompra() -- ver
     * CompraController/CompraComponent no backend. Usar SÓ na criação (não
     * na edição) da Compra -- ver compra-form.component.ts.
     */
    gravarCompra(
        requestBody: unknown
    ): Observable<unknown> {

        return this.http.post(
            '/api/compra/gravar',
            {
                requestBody
            }
        );
    }

    /**
     * Sincroniza (best-effort) um Parceiro RECÉM-CRIADO no Sankhya com o
     * Aerosys — cria a PESSOA (+ PES_DADOS_PF/PES_DADOS_PJ + endereço/
     * telefone/email) equivalente lá. Diferente de gravarPedidoCompra/
     * gravarPreCompra/gravarCompra, o Sankhya já foi gravado ANTES (pelo
     * proxy genérico /api/sankhya, via salvarSankhyaPorEntidade — ver
     * cadastro-parceiro.component.ts#salvarParceiro); esse endpoint só
     * cuida da metade Aerosys, chamado com o CODPARC já criado. Se falhar,
     * o parceiro continua salvo no Sankhya normalmente — ver
     * ParceiroAerosysController/Component no backend.
     */
    /** Envia anexos do parceiro p/ o servidor de documentos do Aerosys (cadastros/Pessoa/{nome}/). */
    enviarAnexosParceiroAerosys(nome: string, arquivos: File[]): Observable<any> {
        const fd = new FormData();
        fd.append('nome', nome);
        arquivos.forEach(a => fd.append('arquivos', a, a.name));
        return this.http.post<any>('/api/parceiro-aerosys/anexos', fd);
    }

    /** Bancos do Sankhya (TSIBCO) para o combo de Referências Bancárias do Parceiro. */
    listarBancosParceiro(): Observable<unknown> {
        return this.http.get('/api/parceiro-aerosys/bancos');
    }

    sincronizarParceiroAerosys(
        payload: unknown
    ): Observable<unknown> {

        return this.http.post(
            '/api/parceiro-aerosys/sincronizar',
            payload
        );
    }

    /**
     * Painel "Peças com Venda nos últimos X meses" (grade de Itens do
     * Pedido de Compra) — combina Qtde Vendida/Ponto Pedido/Estoque
     * EUA/Outros Pedidos/PréCompra do Aerosys com a Qtde Vendida do
     * Sankhya (TGFITE), casando por CODPROD = APE_ID. Endpoint dedicado
     * do GPL-Integracao (não passa pelo proxy genérico /api/sankhya) —
     * ver PedidoCompraAnaliticoController/Component no backend.
     */
    buscarAnaliticoItensPedidoCompra(
        codProds: number[],
        codEmpSankhya: number,
        empresaAerosys: number,
        dtDe: string,
        dtAte: string,
        pcrIdAtual?: number | null
    ): Observable<unknown> {

        return this.http.post(
            '/api/pedido-compra-analitico/itens',
            {
                codProds,
                codEmpSankhya,
                empresaAerosys,
                dtDe,
                dtAte,
                pcrIdAtual: pcrIdAtual ?? null
            }
        );
    }

    /** Fabricante (nome da marca no Sankhya) por CODPROD -- coluna "Fabricante" das listas de importação. */
    buscarFabricantesPorCodProd(codProds: number[]): Observable<any> {
        return this.http.post<any>('/api/pedido-compra-analitico/fabricantes', { codProds });
    }

    /**
     * "Funções > Imp. Peças com Venda nos últimos X meses" (grade de Itens
     * do Pedido de Compra) — descobre quais produtos tiveram venda fechada
     * no período (Aerosys + Sankhya reconciliados), sem lista de CODPROD
     * prévia. Ver PedidoCompraAnaliticoController/Component#buscarDescoberta
     * no backend.
     */
    buscarDescobertaPecasComVenda(
        codEmpSankhya: number,
        empresaAerosys: number,
        dtDe: string,
        dtAte: string
    ): Observable<unknown> {

        return this.http.post(
            '/api/pedido-compra-analitico/descoberta',
            {
                codEmpSankhya,
                empresaAerosys,
                dtDe,
                dtAte
            }
        );
    }

    /**
     * "Funções > Imp. Peças de uma seleção de Vendas" (grade de Itens do
     * Pedido de Compra) — busca vendas já lançadas (Aerosys + Sankhya) por
     * nome de cliente ou número (NUNOTA/N° título), opcionalmente só as de
     * tipo Importação. Ver BuscaVendasController/Component no backend.
     */
    buscarVendasPorTermo(
        codEmpSankhya: number,
        empresaAerosys: number,
        termo: string,
        apenasImportacao: boolean
    ): Observable<unknown> {

        return this.http.post(
            '/api/busca-vendas/buscar',
            {
                codEmpSankhya,
                empresaAerosys,
                termo,
                apenasImportacao
            }
        );
    }

    /**
     * Itens combinados das vendas ESCOLHIDAS na busca acima (uma ou
     * várias, dos dois sistemas) — usado pra popular o checklist de
     * importação. `selecionadas` = [{ sistema: 'sankhya'|'aerosys', id }].
     */
    buscarItensDeVendasSelecionadas(
        empresaAerosys: number,
        selecionadas: { sistema: 'sankhya' | 'aerosys'; id: number }[]
    ): Observable<unknown> {

        return this.http.post(
            '/api/busca-vendas/itens',
            {
                empresaAerosys,
                selecionadas
            }
        );
    }

    /** GET /api/busca-fabricantes -- lista combinada Sankhya (TGFMAR) + Aerosys (FABRICANTE) */
    listarFabricantes(): Observable<unknown> {
        return this.http.get('/api/busca-fabricantes');
    }

    /** GET /api/busca-fabricantes/{codigo}/itens -- peças do fabricante escolhido */
    buscarItensFabricante(codigo: number): Observable<unknown> {
        return this.http.get('/api/busca-fabricantes/' + codigo + '/itens');
    }

    listarPedidosVenda(
        codEmp: number,
        dtDe: string,
        dtAte: string,
        mostrarCancelados: boolean = false,
        termoPn: string = '',
        codVendFiltro: number | string | null = null
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'PedidoVendaGlobalSP.doListarPedidos',
            {
                codEmp,
                dtDe,
                dtAte,
                mostrarCancelados,
                termoPn: termoPn || null,
                codVendFiltro: codVendFiltro || null
            }
        );
    }

    /**
     * @param codTipOper TOP fixa da lista chamadora -- 1300 (Pedido de
     * Compra, default), 1301 (Pré-Compra/Compra). Sem isso, C.TIPMOV = 'O'
     * sozinho misturava as três telas na mesma lista (ver comentário em
     * PedidoCompraRepository#listarPedidos no addon GPL).
     */
    listarPedidosCompra(
        codEmp: number,
        dtDe: string,
        dtAte: string,
        mostrarCancelados: boolean = false,
        termoPn: string = '',
        codTipOper: number = 1300,
        todasEmpresas: boolean = false,
        empresaVirtual: number = 0,
        incluirVirtuais: boolean = false
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'PedidoCompraGlobalSP.doListarPedidos',
            {
                codEmp,
                dtDe,
                dtAte,
                mostrarCancelados,
                termoPn: termoPn || null,
                codTipOper,
                todasEmpresas,
                empresaVirtual,
                incluirVirtuais
            }
        );
    }

    /** Lista de Pré-Compras (TOP 1301) -- mesmo endpoint de listarPedidosCompra, TOP fixa. */
    listarPreCompras(
        codEmp: number,
        dtDe: string,
        dtAte: string,
        mostrarCancelados: boolean = false,
        termoPn: string = '',
        empresaVirtual: number = 0
    ): Observable<unknown> {
        // NACIONAL = 1301, IMPORTAÇÃO = 1303: junta as duas listas.
        return this.listarPorTops(codEmp, dtDe, dtAte, mostrarCancelados, termoPn, [1301, 1303], empresaVirtual);
    }

    /** Lista de Compras: NACIONAL = TOP 1401, IMPORTAÇÃO = TOP 1408. */
    listarCompras(
        codEmp: number,
        dtDe: string,
        dtAte: string,
        mostrarCancelados: boolean = false,
        termoPn: string = '',
        empresaVirtual: number = 0
    ): Observable<unknown> {
        return this.listarPorTops(codEmp, dtDe, dtAte, mostrarCancelados, termoPn, [1401, 1408], empresaVirtual);
    }

    /** Consulta várias TOPs e devolve uma única resposta {responseBody:{sucesso, lista}} ordenada por NUNOTA desc. */
    private listarPorTops(
        codEmp: number,
        dtDe: string,
        dtAte: string,
        mostrarCancelados: boolean,
        termoPn: string,
        tops: number[],
        empresaVirtual: number = 0
    ): Observable<unknown> {
        return forkJoin(
            tops.map(t => this.listarPedidosCompra(codEmp, dtDe, dtAte, mostrarCancelados, termoPn, t, false, empresaVirtual))
        ).pipe(
            map((respostas: any[]) => {
                const lista = respostas
                    .flatMap((r: any) => (r?.responseBody ?? r)?.lista ?? [])
                    .sort((a: any, b: any) => Number(b.nunota ?? 0) - Number(a.nunota ?? 0));
                return { responseBody: { sucesso: true, lista } };
            })
        );
    }

    /** Lista de pedidos > Ações > Status (AUTORIZAR | CANCELAR | ESTORNAR). */
    alterarStatusPedidoCompra(nunota: number, acao: 'AUTORIZAR' | 'CANCELAR' | 'ESTORNAR'): Observable<any> {
        return this.http.post<any>(`/api/pedido-compra/${nunota}/status`, { acao });
    }

    // ── Pré-Venda (TOP 1000): confirmar, status, itens, gerar Venda, desmembrar item ──
    autorizarPreVenda(nunota: number, itens?: { sequencia: number; qtdFat: number }[]): Observable<any> {
        return this.http.post<any>(`/api/pre-venda/${nunota}/autorizar`, itens ? { itens } : {});
    }
    confirmarPreVenda(nunota: number): Observable<any> {
        return this.http.post<any>(`/api/pre-venda/${nunota}/confirmar`, {});
    }
    alterarStatusPreVenda(nunota: number, acao: 'CANCELAR' | 'ESTORNAR'): Observable<any> {
        return this.http.post<any>(`/api/pre-venda/${nunota}/status`, { acao });
    }
    liberacoesPreVenda(nunota: number): Observable<any> {
        return this.http.get<any>(`/api/pre-venda/${nunota}/liberacoes`);
    }
    verificarLiberacoesPreVenda(nunota: number): Observable<any> {
        return this.http.post<any>(`/api/pre-venda/${nunota}/verificar-liberacoes`, {});
    }
    itensPreVenda(nunota: number): Observable<any> {
        return this.http.get<any>(`/api/pre-venda/${nunota}/itens`);
    }
    gerarVendaPreVenda(nunota: number, itens: { sequencia: number; qtdFat: number }[], serie: string = ''): Observable<any> {
        return this.http.post<any>(`/api/pre-venda/${nunota}/gerar-venda`, { itens, serie });
    }
    desmembrarItemPreVenda(nunota: number, sequencia: number): Observable<any> {
        return this.http.post<any>(`/api/pre-venda/${nunota}/desmembrar-item`, { sequencia });
    }

    // ── Pré-Compra: mesmas ações da lista do Pedido de Compra (Status + itens) ──
    alterarStatusPreCompra(nunota: number, acao: 'AUTORIZAR' | 'CANCELAR' | 'ESTORNAR'): Observable<any> {
        return this.http.post<any>(`/api/pre-compra/${nunota}/status`, { acao });
    }

    cancelarItensAbertosPreCompra(nunota: number): Observable<unknown> {
        return this.http.post(`/api/pre-compra/${nunota}/cancelar-itens-abertos`, {});
    }

    cancelarItensSelecionadosPreCompra(nunota: number, sequencias: number[]): Observable<unknown> {
        return this.http.post(`/api/pre-compra/${nunota}/cancelar-itens`, { sequencias });
    }

    reabrirItensPreCompra(nunota: number, sequencias: number[]): Observable<unknown> {
        return this.http.post(`/api/pre-compra/${nunota}/reabrir-itens`, { sequencias });
    }

    cancelarItensAbertosPedidoCompra(nunota: number): Observable<unknown> {
        return this.http.post(`/api/pedido-compra/${nunota}/cancelar-itens-abertos`, {});
    }

    /** Cancela só os itens (SEQUENCIA) informados, que devem estar ABERTOS. */
    cancelarItensSelecionadosPedidoCompra(nunota: number, sequencias: number[]): Observable<unknown> {
        return this.http.post(`/api/pedido-compra/${nunota}/cancelar-itens`, { sequencias });
    }

    /** Desmembra um item PARCIAL em dois (parte comprada + saldo pendente). */
    desmembrarItemPedidoCompra(nunota: number, sequencia: number): Observable<unknown> {
        return this.http.post(`/api/pedido-compra/${nunota}/desmembrar-item`, { sequencia });
    }

    /** Reabre itens CANCELADOS. sequencias vazio = todos os cancelados do pedido. */
    reabrirItensPedidoCompra(nunota: number, sequencias: number[]): Observable<unknown> {
        return this.http.post(`/api/pedido-compra/${nunota}/reabrir-itens`, { sequencias });
    }

    /** Previsão de entrega dos itens (TGFITE.GPL_DTPREVENTREGA). sequencias vazio = todos os itens; data vazia = limpa. */
    atualizarPrevisaoEntregaItens(
        nunota: number,
        data: string,
        sequencias: number[]
    ): Observable<unknown> {
        return this.chamarServiceGpl(
            'PedidoVendaGlobalSP.doAtualizarPrevisaoEntrega',
            { nunota, data, sequencias }
        );
    }

    /** Compra > Importar Pré-Compras: pré-compras AUTORIZADAS/BACKORDERS (Sankhya + Aerosys), deduplicadas. */
    buscarPreComprasCombinadas(codEmp: number): Observable<unknown> {
        return this.http.get('/api/compra/pre-compras/combinadas', { params: { codEmp: String(codEmp) } });
    }

    buscarItensPreComprasSelecionadas(selecao: { nunotaSankhya: number | null; pcpIdAerosys: number | null }[]): Observable<unknown> {
        return this.http.post('/api/compra/pre-compras/itens', selecao);
    }

    buscarDetalhesPedidoVenda(
        nunota: number
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'PedidoVendaGlobalSP.doBuscarDetalhesPedido',
            {
                nunota
            }
        );
    }

    cancelarPedidoVenda(
        nunota: number,
        motivo: string
    ): Observable<unknown> {

        return this.http.post(
            `${this.apiUrl}/cancelar-movimento`,
            {
                nunota,
                motivo
            }
        );
    }

    confirmarMovimentoPedidoVenda(
        nunota: number
    ): Observable<unknown> {

        return this.http.post(
            `${this.apiUrl}/confirmar-movimento`,
            {
                nunota
            }
        );
    }

    alterarTopMovimentoPedidoVenda(
        nunota: number,
        codTipOperNovo: number
    ): Observable<unknown> {

        return this.http.post(
            `${this.apiUrl}/alterar-top-movimento`,
            {
                nunota,
                codTipOperNovo
            }
        );
    }

    alterarTopComReservaPedidoVenda(
        nunota: number,
        codTipOperNovo: number
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'PedidoVendaGlobalSP.doAlterarTopComReserva',
            {
                nunota,
                codTipOperNovo
            }
        );
    }

    atualizarGplStatusPedidoVenda(
        nunota: number,
        novoStatus: string
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'PedidoVendaGlobalSP.doAtualizarGplStatus',
            {
                nunota,
                novoStatus
            }
        );
    }

    duplicarPedidoVenda(
        sourceNunota: number,
        targetCodemp: number,
        seqSelecionados: number[] = []
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'PedidoVendaGlobalSP.doDuplicarPedido',
            {
                sourceNunota,
                targetCodemp,
                seqSelecionados
            }
        );
    }

    dividirPedidoVenda(
        sourceNunota: number,
        itens: {
            seq: number;
            qtd: number;
        }[]
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'PedidoVendaGlobalSP.doDividirPedido',
            {
                sourceNunota,
                itens
            }
        );
    }

    gerarPedidoCompraDeVenda(
        sourceNunota: number,
        itens: {
            seq: number;
            qtd: number;
        }[]
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'PedidoVendaGlobalSP.doGerarPedidoCompraDeVenda',
            {
                sourceNunota,
                itens
            }
        );
    }

    transferirPedidoVenda(
        sourceNunota: number,
        targetCodemp: number
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'PedidoVendaGlobalSP.doTransferirPedido',
            {
                sourceNunota,
                targetCodemp
            }
        );
    }

    buscarFluxoDivisao(
        nunota: number
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'PedidoVendaGlobalSP.doBuscarFluxoDivisao',
            {
                nunota
            }
        );
    }

    atualizarDadosTransporte(
        nunota: number,
        dados: Record<string, unknown>
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'PedidoVendaGlobalSP.doAtualizarDadosTransporte',
            {
                nunota,
                dados
            }
        );
    }

    buscarPrecoExc(
        codprod: number,
        codemp?: number
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'PedidoVendaGlobalSP.doBuscarPrecoExc',
            {
                codprod,
                codemp: codemp ?? 0
            }
        );
    }

    buscarEstoquePorLocal(
        codprod: number
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'PedidoVendaGlobalSP.doBuscarEstoquePorLocal',
            {
                codprod
            }
        );
    }

    buscarVendasControladasMes(
        codprod: number,
        codparc: number,
        nunotaAtual: number
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'PedidoVendaGlobalSP.doBuscarVendasControladasMes',
            {
                codprod,
                codparc,
                nunota: nunotaAtual
            }
        );
    }

    listarComissoesPedido(
        nunota: number
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'PedidoVendaGlobalSP.doListarComissoes',
            {
                nunota
            }
        );
    }

    adicionarComissaoPedido(
        nunota: number,
        codparc: number,
        perccomissao: number
    ): Observable<unknown> {

        const loginusu =
            localStorage.getItem(
                'sankhyaUsername'
            ) ?? '';

        return this.chamarServiceGpl(
            'PedidoVendaGlobalSP.doAdicionarComissao',
            {
                nunota,
                codparc,
                perccomissao,
                loginusu
            }
        );
    }

    removerComissaoPedido(
        codpco: number
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'PedidoVendaGlobalSP.doRemoverComissao',
            {
                codpco
            }
        );
    }

    buscarUsuariosComissao(
        busca: string
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'PedidoVendaGlobalSP.doBuscarUsuariosComissao',
            {
                busca
            }
        );
    }

    autorizarPedidoVenda(
        nunota: number
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'PedidoVendaGlobalSP.doAutorizarPedido',
            {
                nunota
            }
        );
    }

    // listarLiberacoesPendentes(): Observable<unknown> {
    //     return this.chamarServiceGpl(
    //         'PedidoVendaGlobalSP.doListarLiberacoesPendentes',
    //         {}
    //     );
    // }

    /**
     * Formata a data no padrão dd/MM/yyyy esperado pelo Sankhya
     */
    private formatarDataSankhya(data: Date): string {
        const dia = String(data.getDate()).padStart(2, '0');
        const mes = String(data.getMonth() + 1).padStart(2, '0');
        const ano = data.getFullYear();
        return `${dia}/${mes}/${ano}`;
    }

    listarLiberacoesPendentes(codUsu: number): Observable<unknown> {
        // Pega o código numérico do usuário logado
        // const codUsu = this.getCodUsuLogado();

        // Data atual para limites finais (hoje) e data inicial fixa do Sankhya
        const hoje = this.formatarDataSankhya(new Date());
        const dataInicial = "31/12/1969";

        const requestBody = {
            dataSetID: "001",
            entityName: "ViewLiberacaoLimite",
            standAlone: true,
            fields: [
                "VLRLIBERADO", "NUCHAVE", "NUNOTA", "EVENTO",
                "ViewEventoLiberacao.DESCRICAO", "CODUSUSOLICIT",
                "Solicitante.NOMEUSU", "PERCLIMITE", "PERCSOLIC",
                "VLRLIMITE", "VLRATUAL", "DHSOLICIT", "CODUSULIB",
                "Usuario.NOMEUSU", "DHLIB", "PERCANTERIOR", "VLRANTERIOR",
                "SEQUENCIA", "OBSERVACAO", "OBSLIB", "CODPARC",
                "Parceiro.NOMEPARC", "CODEMP", "Empresa.NOMEFANTASIA",
                "CODVEND", "Vendedor.APELIDO", "OBSCOMPL", "CODPARCTRANSP",
                "Transportadora.NOMEPARC", "DTNEG", "CODTIPOPER",
                "TipoOperacao.DESCROPER", "VLRNOTA", "DTVENC", "REPROVADO",
                "CODNAT", "Natureza.DESCRNAT", "CODCENCUS",
                "CentroResultado.DESCRCENCUS", "CODPROJ", "Projeto.IDENTIFICACAO",
                "TOTALDESCONTONOTA", "NURNG", "TABELA", "VLRTOTAL", "NULBO",
                "SUPLEMENTO", "TRANSF", "VLRDESDOB", "DHTIPOPER", "STATUSNOTA",
                "SEQCASCATA", "ORDEM", "NUCLL", "DTPREVENT", "PRECOLIQUIDO",
                "Parceiro.CODCID", "Parceiro.Cidade.NOMECID",
                "Parceiro.ComplementoParc.CODCIDENTREGA",
                "Parceiro.ComplementoParc.Cidade.NOMECID",
                "Parceiro.CGC_CPF"
            ],
            tryJoinedFields: true,
            parallelLoader: true,
            crudListener: "br.com.sankhya.modelcore.crudlisteners.LiberacaoLimitesCrudListener",
            criteria: {
                // Expressão fiel ao payload nativo
                expression: "((this.CODUSULIB = 0 OR this.CODUSULIB = ? OR this.CODUSULIB IN ( SELECT CODUSU FROM TSISUPL WHERE CODUSUSUPL = ? AND DTINICIO <= ? AND ( DTFIM IS NULL OR DTFIM >= ?))) AND (this.DHLIB IS NULL OR (ABS(this.VLRLIBERADO) > 0 AND ABS(this.VLRLIBERADO) < ABS(this.VLRATUAL))) AND this.DHSOLICIT >= ? AND onlydate(this.DHSOLICIT) <= ? AND this.EVENTO <> 24 AND this.EVENTO IN ( SELECT EVENTO FROM TSILIM LIM WHERE (( LIM.CODUSU = ? OR LIM.CODUSU IN ( SELECT CODUSU FROM TSISUPL WHERE TSISUPL.CODUSUSUPL = ? AND TSISUPL.DTINICIO <= ? AND (TSISUPL.DTFIM IS NULL OR TSISUPL.DTFIM >= ? ))) AND LIM.CODGRU = 0) OR (LIM.CODUSU = 0 AND (LIM.CODGRU = ? OR LIM.CODGRU IN ( SELECT U.CODGRUPO FROM TSISUPL S, TSIUSU U WHERE  S.CODUSUSUPL = ? AND S.DTINICIO <= ? AND (S.DTFIM IS NULL OR S.DTFIM >= ?) AND S.CODUSU = U.CODUSU)))))",
                parameters: [
                    { type: "N", value: codUsu },
                    { type: "N", value: codUsu },
                    { type: "D", value: dataInicial },
                    { type: "D", value: hoje },
                    { type: "D", value: dataInicial },
                    { type: "D", value: hoje },
                    { type: "N", value: codUsu },
                    { type: "N", value: codUsu },
                    { type: "D", value: dataInicial },
                    { type: "D", value: hoje },
                    { type: "N", value: codUsu },
                    { type: "N", value: codUsu },
                    { type: "D", value: dataInicial },
                    { type: "D", value: hoje }
                ]
            },
            txProperties: {
                ConfigToSaveAt: "br.com.sankhya.liberacao.limites.DynamicFilterAccordion",
                eyJwcm9nQ3JpdGVyaWEiOltdfQ: "=="
            },
            ignoreListenerMethods: "",
            useDefaultRowsLimit: true,
            clientEventList: {
                clientEvent: [
                    { $: "br.com.sankhya.actionbutton.clientconfirm" }
                ]
            }
        };

        return this.proxy('mge', 'DatasetSP.loadRecords', requestBody);
    }

    aprovarLiberacaoNativa(
        codUsu: number,
        itensLiberacao: Array<{
            nuChave: number;
            evento: number;
            nucll: number;
            seqCascata: number;
            sequencia: number;
            tabela: string;
        }>
    ): Observable<unknown> {
        const requestBody = {
            params: {
                itens: itensLiberacao,
                usuario: codUsu,
                liberar: "S",
                obsLib: "",
                vlrLib: 0,
                confirmarNotaAutomaticamente: "true",
                compensarNotaAutomaticamente: "false"
            },
            clientEventList: {
                clientEvent: [
                    { $: "br.com.sankhya.actionbutton.clientconfirm" }
                ]
            }
        };

        return this.proxy('mge', 'LiberacaoLimitesSP.liberarNegarLimites', requestBody);
    }

    confirmarNotasNativa(nunota: number): Observable<unknown> {
        const requestBody = {
            notas: {
                compensarNotaAutomaticamente: "false",
                nunota: { $: String(nunota) }
            },
            clientEventList: {
                clientEvent: [
                    { $: "br.com.sankhya.actionbutton.clientconfirm" }
                ]
            }
        };

        return this.proxy('mgecom', 'ServicosNfeSP.confirmarNotas', requestBody);
    }

    gplStatusAutorizado(
        nunota: number
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'PedidoVendaGlobalSP.doAprovarLiberacao',
            {
                nunota
            }
        );
    }

    reprovarLiberacaoNativa(
        codUsu: number,
        itensLiberacao: Array<{
            nuChave: number;
            evento: number;
            nucll: number;
            seqCascata: number;
            sequencia: number;
            tabela: string;
        }>,
        justificativa: string
    ): Observable<unknown> {
        const requestBody = {
            params: {
                itens: itensLiberacao,
                usuario: codUsu,
                liberar: "N", // "N" de Negar/Reprovar
                obsLib: justificativa, // Texto digitado pelo gestor
                vlrLib: 0,
                confirmarNotaAutomaticamente: "true",
                compensarNotaAutomaticamente: "false"
            },
            clientEventList: {
                clientEvent: [
                    { $: "br.com.sankhya.actionbutton.clientconfirm" }
                ]
            }
        };

        // Usa o módulo 'mge' exatamente como na aprovação
        return this.proxy('mge', 'LiberacaoLimitesSP.liberarNegarLimites', requestBody);
    }

    reprovarLiberacao(
        nunota: number,
        justificativa: string
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'PedidoVendaGlobalSP.doReprovarLiberacao',
            {
                nunota,
                justificativa
            }
        );
    }

    listarEtiquetaConfigs(): Observable<unknown> {
        return this.chamarServiceGpl(
            'EtiquetaGlobalSP.doListarConfigs',
            {}
        );
    }

    buscarEtiquetaConfig(
        codconfig: number
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'EtiquetaGlobalSP.doBuscarConfig',
            {
                CODCONFIG: codconfig
            }
        );
    }

    salvarEtiquetaConfig(
        payload: {
            CODCONFIG?: number;
            NOME: string;
            LARGURA_MM: number;
            ALTURA_MM: number;
            DADOS_JSON: string;
        }
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'EtiquetaGlobalSP.doSalvarConfig',
            payload
        );
    }

    excluirEtiquetaConfig(
        codconfig: number
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'EtiquetaGlobalSP.doExcluirConfig',
            {
                CODCONFIG: codconfig
            }
        );
    }

    listarEtiquetaFontes(): Observable<unknown> {
        return this.chamarServiceGpl(
            'EtiquetaGlobalSP.doListarFontes',
            {}
        );
    }

    buscarDadosImpressaoEtiqueta(
        codconfig: number,
        codemp: number,
        nunota?: number,
        codprod?: number
    ): Observable<unknown> {

        const payload: any = {
            CODCONFIG: codconfig,
            CODEMP: codemp
        };

        if (nunota) {
            payload.NUNOTA = nunota;
        }

        if (codprod) {
            payload.CODPROD = codprod;
        }

        return this.chamarServiceGpl(
            'EtiquetaGlobalSP.doBuscarDadosImpressao',
            payload
        );
    }

    listarMotivosCancelamento(
        modulo?: string
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'MotivoCancelamentoGlobalSP.doListarMotivos',
            {
                modulo: modulo ?? ''
            }
        );
    }

    buscarOpcoesMotivosCancelamento(): Observable<unknown> {
        return this.chamarServiceGpl(
            'MotivoCancelamentoGlobalSP.doBuscarOpcoes',
            {}
        );
    }

    salvarMotivoCancelamento(
        payload: {
            codigo?: number;
            motivo: string;
            ativo: string;
            modulo: string;
            codUsu?: number;
        }
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'MotivoCancelamentoGlobalSP.doSalvarMotivo',
            payload
        );
    }

    alterarAtivoMotivoCancelamento(
        codigo: number,
        ativo: string
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'MotivoCancelamentoGlobalSP.doAlterarAtivo',
            {
                codigo,
                ativo
            }
        );
    }

    listarParametros(): Observable<unknown> {
        return this.chamarServiceGpl(
            'ParametroGlobalSP.doListarParametros',
            {}
        );
    }

    buscarOpcoesParametro(): Observable<unknown> {
        return this.chamarServiceGpl(
            'ParametroGlobalSP.doBuscarOpcoes',
            {}
        );
    }

    /** Busca vários valores de parâmetro de uma vez (ex.: ['ALTCOT','FABNAC']). */
    buscarValoresParametros(
        nomes: string[]
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'ParametroGlobalSP.doBuscarValores',
            {
                nomes
            }
        );
    }

    salvarParametro(
        payload: {
            codigo?: number;
            nome: string;
            valor: string;
            descricao?: string;
            ativo: string;
        }
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'ParametroGlobalSP.doSalvarParametro',
            payload
        );
    }

    alterarAtivoParametro(
        codigo: number,
        ativo: string
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'ParametroGlobalSP.doAlterarAtivo',
            {
                codigo,
                ativo
            }
        );
    }

    buscarListaRegras(): Observable<unknown> {
        return this.chamarServiceGpl(
            'RegraComissaoGlobalSP.doBuscarListaRegras',
            {}
        );
    }

    buscarDetalhesRegra(
        payload: {
            codRegra: any;
        }
    ): any {

        return this.chamarServiceGpl(
            'RegraComissaoGlobalSP.doBuscarDetalhesRegra',
            payload
        );
    }

    excluirRegraComissao(
        payload: any
    ) {

        return this.chamarServiceGpl(
            'RegraComissaoGlobalSP.doExcluirRegra',
            payload
        );
    }

    salvarRegraComissao(
        payload: any
    ) {

        return this.chamarServiceGpl(
            'RegraComissaoGlobalSP.doSalvarComissao',
            payload
        );
    }

    buscarGrupos() {
        return this.chamarServiceGpl(
            'GrupoProdutosGlobalSP.doBuscarGrupos',
            {}
        );
    }

    buscarVendedores() {
        return this.chamarServiceGpl(
            'VendedorGlobalSP.doBuscarVendedores',
            {}
        );
    }

    simularComissao(
        payload: any
    ) {

        return this.chamarServiceGpl(
            'ComissaoGlobalSP.doSimularComissaoPorRegra',
            payload
        );
    }

    consultarComissoesAnaliticas(
        payload: any
    ) {

        return this.chamarServiceGpl(
            'ComissaoGlobalSP.doProcessarCalculoAnalitico',
            payload
        );
    }

    listarMonitoramentoAtividadeAcessos(): Observable<AtividadeAcessoMonitoramentoResponse> {
        return this.http.get<AtividadeAcessoMonitoramentoResponse>(
            `${this.apiUrl}/atividade-acessos/monitoramento`
        );
    }

    listarTelasControleAcesso(
        itemPai?: any
    ): Observable<unknown> {

        const level =
            itemPai
                ? {
                    id:
                        itemPai.id ??
                        itemPai.codigo,

                    descricao:
                        itemPai.descricao ??
                        itemPai.nome,

                    contexto:
                        itemPai.contexto ??
                        itemPai.modulo,

                    temFilhos:
                    itemPai.temFilhos,

                    controle:
                    itemPai.controle,

                    adicional:
                    itemPai.adicional,

                    showInfoTelaPersonalizada:
                    itemPai.showInfoTelaPersonalizada,

                    accessMode:
                        true
                }
                : {
                    accessMode: true
                };

        return this.proxy(
            'mge',
            'WorkspaceSP.getItensMenuAtLevel',
            {
                level
            }
        );
    }

    listarPermissaoAcessoControleAcesso(
        resourceID: string,
        tipoAlvo: 'GRUPO' | 'USUARIO',
        codigoAlvo?: string | number
    ): Observable<unknown> {

        const modoAcesso =
            tipoAlvo === 'USUARIO'
                ? 'usuario'
                : 'grupo';

        const alvo =
            codigoAlvo
                ? {
                    usuarios: {
                        usuario: {
                            value:
                                String(
                                    codigoAlvo
                                )
                        }
                    }
                }
                : {};

        return this.proxy(
            'mge',
            'ControleAcessoSP.getPermissaoAcesso',
            {
                permissao: {
                    modoAcesso,

                    itens: {
                        item: {
                            resourceID
                        }
                    },

                    ...alvo
                },

                clientEventList: {}
            }
        );
    }

    atualizarPermissaoAcessoControleAcesso(
        payload: any
    ): Observable<unknown> {

        return this.proxy(
            'mge',
            'ControleAcessoSP.atualizarPermissaoAcesso',
            payload
        );
    }

    deletarPermissaoAcessoControleAcesso(
        payload: any
    ): Observable<unknown> {

        return this.proxy(
            'mge',
            'ControleAcessoSP.deletarPermissaoAcesso',
            payload
        );
    }

    listarEntidadesAcessoControleAcesso(
        resourceIDs: string[],
        tipoAlvo: 'GRUPO' | 'USUARIO' = 'USUARIO',
        semAcesso: boolean = false
    ): Observable<unknown> {

        const modoAcesso =
            tipoAlvo === 'USUARIO'
                ? 'usuario'
                : 'grupo';

        return this.proxy(
            'mge',
            'ControleAcessoSP.getEntidadesAcesso',
            {
                itens: {
                    modoAcesso,

                    semAcesso:
                        semAcesso
                            ? 'true'
                            : 'false',

                    considerarAcessoNegado:
                        'true',

                    item:
                        resourceIDs.map(
                            (resourceID) => ({
                                resourceID
                            })
                        )
                },

                clientEventList: {}
            }
        );
    }

    /*
     * SEPARAÇÃO
     */

    buscarPedidosSeparacao(
        codusu: number = 0,
        codEmp: number = 0
    ): Observable<any> {

        return this.http.get(
            `${this.apiUrl}/separacao/buscar?codusu=${codusu}&codEmp=${codEmp}`
        );
    }

    buscarPedidosConferencia(): Observable<any> {
        return this.http.get(
            `${this.apiUrl}/separacao/buscar-conferencia`
        );
    }

    iniciarSeparacao(
        nunota: number,
        numTag: string
    ): Observable<any> {

        return this.http.post(
            `${this.apiUrl}/separacao/iniciar/${nunota}?numTag=${encodeURIComponent(numTag)}`,
            {}
        );
    }

    atualizarProgressoSeparacao(
        nunota: number,
        qtd: number
    ): Observable<any> {

        return this.http.put(
            `${this.apiUrl}/separacao/progresso/${nunota}?qtd=${qtd}`,
            {}
        );
    }

    getEstadoItensSeparacao(
        nunota: number
    ): Observable<any> {

        return this.http.get(
            `${this.apiUrl}/separacao/estado-itens/${nunota}`
        );
    }

    salvarEstadoItemSeparacao(
        nunota: number,
        seq: number,
        separado: boolean
    ): Observable<any> {

        return this.http.put(
            `${this.apiUrl}/separacao/item/${nunota}/${seq}?separado=${separado}`,
            {}
        );
    }

    dividirSeparacao(
        nunota: number,
        separadores: number[]
    ): Observable<any> {

        return this.http.post(
            `${this.apiUrl}/separacao/dividir/${nunota}`,
            separadores
        );
    }

    finalizarSeparacao(
        nunota: number
    ): Observable<any> {

        return this.http.post(
            `${this.apiUrl}/separacao/finalizar/${nunota}`,
            {}
        );
    }

    /** Estorna um pedido em separação de volta para ABERTO — remove os dados
     *  de separação (GPL_SEPARACAO_ITENS/GPL_SEPARACAO_ESTOQUE) desse pedido. */
    estornarSeparacao(nunota: number): Observable<any> {
        return this.http.post(`${this.apiUrl}/separacao/estornar/${nunota}`, {});
    }

    buscarUsuariosSeparacao(
        busca: string
    ): Observable<any> {

        return this.http.get(
            `${this.apiUrl}/separacao/usuarios-sep?busca=${encodeURIComponent(busca)}`
        );
    }

    buscarMeuCodusu(): Observable<any> {
        return this.http.get(
            `${this.apiUrl}/separacao/meu-codusu`
        );
    }

    transferirSeparacao(
        nunota: number,
        codUsuDestino: number
    ): Observable<any> {

        return this.http.post(
            `${this.apiUrl}/separacao/transferir/${nunota}?codUsuDestino=${codUsuDestino}`,
            {}
        );
    }

    /*
     * CONFERÊNCIA
     */

    buscarPedidosConferenciaEstoque(
        codusu: number = 0,
        codEmp: number = 0
    ): Observable<any> {

        return this.http.get(
            `${this.apiUrl}/conferencia/buscar?codusu=${codusu}&codEmp=${codEmp}`
        );
    }

    // ── PENDÊNCIA "ITEM NO OUTRO GALPÃO" (Separação nativa) ─────────────────
    // Equivalente nativo do fluxo Legado (ver AerosysGatewayService). CODUSU
    // é sempre resolvido no Sankhya via sessão logada -- nenhum destes
    // métodos pede/envia identificação de usuário.

    /** Sinaliza um item como "Item no outro Galpão" -- não trava a fila, o separador segue pro próximo. */
    sinalizarPendenciaSeparacao(nunota: number, sequencia: number, observacao?: string | null): Observable<any> {
        return this.http.post(`${this.apiUrl}/pendencia-separacao/sinalizar`, {nunota, sequencia, observacao: observacao ?? ''});
    }

    /** Desfaz uma sinalização feita por engano (dentro da mesma sessão de separação). */
    desfazerPendenciaSeparacao(nunota: number, sequencia: number): Observable<any> {
        return this.http.post(`${this.apiUrl}/pendencia-separacao/desfazer`, {nunota, sequencia});
    }

    /** Resolve a pendência (item foi buscado no outro galpão) -- usado pela tela "Itens Pendentes". */
    resolverPendenciaSeparacao(nunota: number, sequencia: number): Observable<any> {
        return this.http.post(`${this.apiUrl}/pendencia-separacao/resolver`, {nunota, sequencia});
    }

    // ── Pendência "Item no outro Galpão" (Conferência nativa) ─────────────────

    /** Sinaliza um item como "Item no outro Galpão" -- não trava a conferência cega dos demais itens. */
    sinalizarPendenciaConferencia(nunota: number, sequencia: number, observacao?: string | null): Observable<any> {
        return this.http.post(`${this.apiUrl}/pendencia-conferencia/sinalizar`, {nunota, sequencia, observacao: observacao ?? ''});
    }

    /** Desfaz uma sinalização feita por engano (dentro da mesma sessão de conferência). */
    desfazerPendenciaConferencia(nunota: number, sequencia: number): Observable<any> {
        return this.http.post(`${this.apiUrl}/pendencia-conferencia/desfazer`, {nunota, sequencia});
    }

    /** Resolve a pendência (item foi buscado no outro galpão) -- usado pela tela "Itens Pendentes". */
    resolverPendenciaConferencia(nunota: number, sequencia: number): Observable<any> {
        return this.http.post(`${this.apiUrl}/pendencia-conferencia/resolver`, {nunota, sequencia});
    }

    /** Fila global (todas as vendas nativas) de pendências de Conferência ABERTAS -- tela "Itens Pendentes". */
    listarPendenciasConferencia(): Observable<any> {
        return this.http.get(`${this.apiUrl}/pendencia-conferencia/buscar`);
    }

    /** Fila global (todas as vendas nativas) de pendências abertas -- tela "Itens Pendentes". */
    listarPendenciasSeparacao(): Observable<any> {
        return this.http.get(`${this.apiUrl}/pendencia-separacao/buscar`);
    }

    // ── CONFERÊNCIA DE ESTOQUE ─────────────────────────────────────────────
    iniciarConferencia(
        nunota: number
    ): Observable<any> {

        return this.http.post(
            `${this.apiUrl}/conferencia/iniciar/${nunota}`,
            {}
        );
    }

    getEstadoItensConferencia(
        nunota: number
    ): Observable<any> {

        return this.http.get(
            `${this.apiUrl}/conferencia/estado-itens/${nunota}`
        );
    }

    salvarItemConferencia(
        nunota: number,
        seq: number,
        conferido: boolean,
        observacao?: string
    ): Observable<any> {

        let url =
            `${this.apiUrl}/conferencia/item/${nunota}/${seq}?conferido=${conferido}`;

        if (
            observacao != null
        ) {
            url +=
                `&observacao=${encodeURIComponent(observacao)}`;
        }

        return this.http.put(
            url,
            {}
        );
    }

    finalizarConferencia(
        nunota: number
    ): Observable<any> {

        return this.http.post(
            `${this.apiUrl}/conferencia/finalizar/${nunota}`,
            {}
        );
    }

    finalizarConferenciaClienteRetira(
        nunota: number
    ): Observable<any> {

        return this.http.post(
            `${this.apiUrl}/conferencia/finalizar-cliente-retira/${nunota}`,
            {}
        );
    }

    estornarConferencia(
        nunota: number
    ): Observable<any> {

        return this.http.post(
            `${this.apiUrl}/conferencia/estornar/${nunota}`,
            {}
        );
    }

    /** Transfere a conferência ativa para outro conferente -- mesmo padrão
     *  de transferirSeparacao. */
    transferirConferencia(
        nunota: number,
        codUsuDestino: number
    ): Observable<any> {

        return this.http.post(
            `${this.apiUrl}/conferencia/transferir/${nunota}?codUsuDestino=${codUsuDestino}`,
            {}
        );
    }

    /** Busca usuários pra transferir a conferência -- reaproveita o mesmo
     *  endpoint genérico de busca de usuários da Separação (buscarUsuariosSep
     *  não filtra nada específico de separação, é uma busca simples em TSIUSU). */
    buscarUsuariosConferencia(
        busca: string
    ): Observable<any> {

        return this.buscarUsuariosSeparacao(busca);
    }

    /*
     * LOGÍSTICA
     */

    buscarPedidosLogistica(
        codEmp: number = 0
    ): Observable<any> {

        return this.http.get(
            `${this.apiUrl}/logistica/buscar?codEmp=${codEmp}`
        );
    }

    confirmarEnvioLogistica(
        nunota: number,
        tipoFinalizacao: 'DIRETO' | 'ITENS' = 'DIRETO',
        qtdItens: number = 0,
        qtdVerificados: number = 0
    ): Observable<any> {

        return this.http.post(
            `${this.apiUrl}/logistica/confirmar-envio`,
            {
                nunota,
                tipoFinalizacao,
                qtdItens,
                qtdVerificados
            }
        );
    }

    estornarLogistica(
        nunota: number
    ): Observable<any> {

        return this.http.post(
            `${this.apiUrl}/logistica/estornar/${nunota}`,
            {}
        );
    }

    /*
     * PENDÊNCIA VENDEDOR
     */

    enviarPendenciaVendedor(
        nunota: number,
        observacao: string
    ): Observable<any> {

        return this.http.post(
            `${this.apiUrl}/pendencia-vendedor/enviar`,
            {
                nunota,
                observacao
            }
        );
    }

    resolverPendenciaVendedor(
        nunota: number
    ): Observable<any> {

        return this.http.post(
            `${this.apiUrl}/pendencia-vendedor/resolver`,
            {
                nunota
            }
        );
    }

    buscarPendenciasVendedor(
        codusu: number = 0
    ): Observable<any> {

        return this.http.get(
            `${this.apiUrl}/pendencia-vendedor/buscar`,
            {
                params: {
                    codusu:
                        String(
                            codusu
                        )
                }
            }
        );
    }

    buscarItensPendentesPendencia(
        nunota: number
    ): Observable<any> {

        return this.http.get(
            `${this.apiUrl}/pendencia-vendedor/itens/${nunota}`
        );
    }

    getSankhyaBaseUrl(): Observable<any> {
        return this.http.get<any>(
            `${this.apiUrl}/config/sankhya-url`
        );
    }

    /*
     * PARCEIROS
     */

    buscarParceiroPorCpfCnpj(
        cpfCnpj: string
    ): Observable<unknown> {

        return this.chamarServiceGpl(
            'ParceiroGlobalSP.doBuscarParceiroPorCpfCnpj',
            {
                CGC_CPF:
                cpfCnpj
            }
        );
    }

    salvarSankhyaPorEntidade(
        payload: any
    ): Observable<unknown> {

        return this.proxy(
            'mge',
            'DatasetSP.save',
            payload
        );
    }

    buscarCidades(
        termo: string
    ) {

        const requestBody: any = {
            entityName: 'Cidade',
            fields: [
                'CODCID',
                'NOMECID',
                'UF'
            ]
        };

        if (
            termo &&
            termo.trim() !== ''
        ) {
            requestBody.criteria = {
                expression:
                    'UPPER(NOMECID) LIKE UPPER(?)',

                parameters: [
                    {
                        type: 'S',
                        value:
                            `%${termo}%`
                    }
                ]
            };
        }

        return this.proxy(
            'mge',
            'DatasetSP.loadRecords',
            requestBody
        );
    }

    buscarUfs() {

        const requestBody: any = {
            entityName:
                'UnidadeFederativa',

            fields: [
                'CODUF',
                'UF',
                'DESCRICAO'
            ]
        };

        return this.proxy(
            'mge',
            'DatasetSP.loadRecords',
            requestBody
        );
    }

    buscarBairros(
        termo: string
    ) {

        const requestBody: any = {
            entityName:
                'Bairro',

            fields: [
                'CODBAI',
                'NOMEBAI'
            ]
        };

        if (
            termo &&
            termo.trim() !== ''
        ) {
            requestBody.criteria = {
                expression:
                    'UPPER(NOMEBAI) LIKE UPPER(?)',

                parameters: [
                    {
                        type:
                            'S',

                        value:
                            `%${termo}%`
                    }
                ]
            };
        }

        return this.proxy(
            'mge',
            'DatasetSP.loadRecords',
            requestBody
        );
    }

    buscarLogradouros(
        termo: string
    ) {

        const requestBody: any = {
            entityName:
                'Endereco',

            fields: [
                'CODEND',
                'NOMEEND'
            ]
        };

        if (
            termo &&
            termo.trim() !== ''
        ) {
            requestBody.criteria = {
                expression:
                    'UPPER(NOMEEND) LIKE UPPER(?)',

                parameters: [
                    {
                        type:
                            'S',

                        value:
                            `%${termo}%`
                    }
                ]
            };
        }

        return this.proxy(
            'mge',
            'DatasetSP.loadRecords',
            requestBody
        );
    }

    /** Vinculos de parceiros das aeronaves (AD_AEROPAR): CODAERO, TIPO_VINCULO. */
    listarVinculosAeronaves() {
        return this.proxy('mge', 'DatasetSP.loadRecords', {
            entityName: 'AD_AEROPAR',
            fields: ['CODAERO', 'TIPO_VINCULO']
        });
    }

    /** Lista do cadastro de aeronaves (AD_TCADAERO): colunas da Lista de Aeronaves, na ordem de `fields`. */
    listarAeronavesCadastro() {
        return this.proxy('mge', 'DatasetSP.loadRecords', {
            entityName: 'AD_TCADAERO',
            fields: ['CODAERO', 'CLASSEAERONAVE', 'MODELO', 'FABRICANTE', 'PREFIXO', 'NUMEROSERIE', 'ANOFABRICACAO', 'PROPRIETARIO', 'CPFCNPJ']
        });
    }

    buscarAeronaves(
        termo: string
    ) {

        const requestBody: any = {
            entityName:
                'AD_TCADAERO',

            fields: [
                'CODAERO',
                'PREFIXO'
            ]
        };

        if (
            termo &&
            termo.trim() !== ''
        ) {
            requestBody.criteria = {
                expression:
                    'UPPER(PREFIXO) LIKE UPPER(?)',

                parameters: [
                    {
                        type:
                            'S',

                        value:
                            `%${termo}%`
                    }
                ]
            };
        }

        return this.proxy(
            'mge',
            'DatasetSP.loadRecords',
            requestBody
        );
    }

    cadastrarLogradouro(
        tipo: string,
        nome: string
    ) {

        const requestBody = {
            entityName:
                'Endereco',

            standAlone:
                false,

            fields: [
                'CODEND',
                'NOMEEND',
                'TIPO'
            ],

            records: [
                {
                    values: {
                        '1':
                            nome.toUpperCase(),

                        '2':
                            tipo.toUpperCase()
                    }
                }
            ]
        };

        return this.proxy(
            'mge',
            'DatasetSP.save',
            requestBody
        );
    }

    cadastrarCidade(
        nome: string,
        uf: string
    ) {

        const requestBody = {
            entityName:
                'Cidade',

            standAlone:
                false,

            fields: [
                'CODCID',
                'NOMECID',
                'UF'
            ],

            records: [
                {
                    values: {
                        '1':
                            nome.toUpperCase(),

                        '2':
                            uf.toUpperCase()
                    }
                }
            ]
        };

        return this.proxy(
            'mge',
            'DatasetSP.save',
            requestBody
        );
    }

    cadastrarBairro(
        nome: string
    ) {

        const requestBody = {
            entityName:
                'Bairro',

            standAlone:
                false,

            fields: [
                'CODBAI',
                'NOMEBAI',
                'DESCRICAOCORREIO'
            ],

            records: [
                {
                    values: {
                        '1':
                            nome.toUpperCase(),

                        '2':
                            nome.toUpperCase()
                    }
                }
            ]
        };

        return this.proxy(
            'mge',
            'DatasetSP.save',
            requestBody
        );
    }

    downloadAnexo(
        idAnexo: string
    ) {

        const url =
            `/api/sankhya/mge/arquivo/download.mge?chave=${idAnexo}`;

        return this.http.get(
            url,
            {
                responseType:
                    'blob',

                observe:
                    'response'
            }
        );
    }

    /** Ordem salva dos anexos do parceiro (GPL_PARCEIRO_ANEXO_ORDEM, addon). */
    buscarOrdemAnexosParceiro(codParc: number | string): Observable<any> {
        return this.chamarServiceGpl('ParceiroGlobalSP.doBuscarOrdemAnexos', { CODPARC: codParc }) as Observable<any>;
    }

    gravarOrdemAnexosParceiro(codParc: number | string, arquivos: string[]): Observable<any> {
        return this.chamarServiceGpl('ParceiroGlobalSP.doGravarOrdemAnexos', { CODPARC: codParc, ARQUIVOS: arquivos }) as Observable<any>;
    }

    excluirAnexoParceiro(codParc: number | string, descricao: string): Observable<any> {
        return this.chamarServiceGpl('ParceiroGlobalSP.doExcluirAnexoParceiro', { CODPARC: codParc, DESCRICAO: descricao }) as Observable<any>;
    }

    salvarAnexoParceiro(
        file: File,
        descricao: string,
        codParc: number | string
    ) {

        const formData =
            new FormData();

        formData.append(
            'descricao',
            descricao
        );

        formData.append(
            'conteudo',
            file
        );

        const url =
            `/api/sankhya/uploadAnexo.mge?tipo=P&codata=${codParc}&sequencia=0`;

        return this.http.post(
            url,
            formData,
            {
                responseType:
                    'text'
            }
        );
    }

    downloadAnexoParceiro(
        codParc: string | number,
        descricao: string
    ): Observable<unknown> {

        const requestBody = {
            anexo: {
                codata:
                codParc,

                sequencia:
                    0,

                tipo:
                    'P',

                descricao,

                tipoConteudo:
                    'X'
            },

            clientEventList: {
                clientEvent: [
                    {
                        '$':
                            'parceiro.mostra.mensagem.criticaie'
                    },
                    {
                        '$':
                            'br.com.sankhya.mgecore.ie.repetida.transportadora'
                    },
                    {
                        '$':
                            'br.com.sankhya.actionbutton.clientconfirm'
                    }
                ]
            }
        };

        return this.proxy(
            'mge',
            'Attach.view',
            requestBody
        );
    }

    buscarAnexosParceiro(
        codParc: string | number
    ): Observable<unknown> {

        const requestBody = {
            criteria: {
                codata:
                codParc,

                sequencia:
                    0,

                tipoAnexo:
                    'P'
            }
        };

        return this.proxy(
            'mge',
            'Attach.load',
            requestBody
        );
    }

    gerarTokenDownloadAnexo(
        codParc: string | number,
        descricao: string
    ): Observable<unknown> {

        const requestBody = {
            anexo: {
                codata:
                codParc,

                sequencia:
                    0,

                tipo:
                    'P',

                descricao,

                tipoConteudo:
                    'N'
            }
        };

        return this.proxy(
            'mge',
            'Attach.view',
            requestBody
        );
    }

    buscarDadosReceitaWS(
        cnpj: string
    ): Observable<any> {

        const cnpjLimpo =
            cnpj.replace(
                /\D/g,
                ''
            );

        return this.http.post(
            `${this.apiUrl}/receitaws`,
            {
                cnpj:
                cnpjLimpo
            }
        );
    }

    excluirParceiroSankhya(
        codparc: string
    ): Observable<unknown> {

        const payload = {
            dataSetID:
                '00Z',

            entityName:
                'Parceiro',

            standAlone:
                false,

            pks: [
                {
                    CODPARC:
                    codparc
                }
            ],

            crudListener:
                'br.com.sankhya.modelcore.crudlisteners.ParceiroCrudListener',

            ignoreListenerMethods:
                '',

            clientEventList: {
                clientEvent: [
                    {
                        '$':
                            'parceiro.mostra.mensagem.criticaie'
                    },
                    {
                        '$':
                            'br.com.sankhya.mgecore.ie.repetida.transportadora'
                    },
                    {
                        '$':
                            'br.com.sankhya.actionbutton.clientconfirm'
                    }
                ]
            }
        };

        return this.proxy(
            'mge',
            'DatasetSP.removeRecord',
            payload
        );
    }

    buscarParceiros(
        termo: string,
        tipo?:
            'CLIENTE' |
            'FORNECEDOR' |
            'TRANSPORTADORA'
    ): Observable<unknown> {

        const requestBody: any = {
            entityName:
                'Parceiro',

            fields: [
                'CODPARC',
                'NOMEPARC',
                'CGC_CPF'
            ]
        };

        const conditions:
            string[] =
            [];

        const parameters:
            any[] =
            [];

        if (
            termo &&
            termo.trim() !== ''
        ) {
            const termoBusca =
                termo.trim();

            const termoApenasNumeros =
                termoBusca.replace(
                    /\D/g,
                    ''
                );

            if (
                termoApenasNumeros.length >
                0
            ) {
                conditions.push(
                    '(UPPER(NOMEPARC) LIKE UPPER(?) OR CGC_CPF LIKE ? OR TO_CHAR(CODPARC) = ?)'
                );

                parameters.push({
                    type:
                        'S',

                    value:
                        `%${termoBusca}%`
                });

                parameters.push({
                    type:
                        'S',

                    value:
                        `%${termoApenasNumeros}%`
                });

                parameters.push({
                    type:
                        'S',

                    value:
                    termoApenasNumeros
                });

            } else {
                conditions.push(
                    'UPPER(NOMEPARC) LIKE UPPER(?)'
                );

                parameters.push({
                    type:
                        'S',

                    value:
                        `%${termoBusca}%`
                });
            }
        }

        if (tipo) {
            conditions.push(
                `${tipo} = 'S'`
            );
        }

        if (
            conditions.length >
            0
        ) {
            requestBody.criteria = {
                expression:
                    conditions.join(
                        ' AND '
                    ),

                parameters
            };
        }

        return this.proxy(
            'mge',
            'DatasetSP.loadRecords',
            requestBody
        );
    }

    buscarAeronavePorPrefixo(
        prefixo: string
    ) {

        return this.chamarServiceGpl(
            'AeronaveGlobalSP.doBuscarAeronavePorPrefixo',
            {
                PREFIXO:
                prefixo
            }
        );
    }

    buscarParceirosAgrupados(termo: string): Observable<any> {
        return this.chamarServiceGpl(
            'ParceiroGlobalSP.doBuscarParceirosAgrupadosPorDocumento',
            {
                CONSULTA:
                termo
            }
        );
    }

    buscarAeronavesComProprietario(
        consulta: string
    ) {

        return this.chamarServiceGpl(
            'AeronaveGlobalSP.doBuscarAeronavePorPrefixoEProprietario',
            {
                CONSULTA:
                consulta
            }
        );
    }

    buscarAeronaveAnac(
        prefixo: string
    ) {

        return this.http.post(
            `${this.apiUrl}/aeronaves/consultar-anac`,
            {
                prefixo
            }
        );
    }

    /*
     * DEMONSTRATIVO DE VENDAS
     */

    buscarDadosNativosDemonstrativo(
        payload: {
            CODPARC: string | number;
            DTINICIAL: string;
            DTFINAL: string;
            TIPO_BUSCA: 'CLIENTE';
        }
    ): Observable<
        SankhyaEnvelope<DemonstrativoDados>
    > {

        return this.http.post<
            SankhyaEnvelope<DemonstrativoDados>
        >(
            `${this.apiUrl}/demonstrativo/dados-nativos`,
            payload
        );
    }

    buscarClientesNativo(
        termo: string
    ): Observable<unknown> {

        const termoNormalizado =
            String(
                termo ||
                ''
            )
                .trim()
                .replace(
                    /[.\/-]/g,
                    ''
                );

        return this.http.post(
            `${this.apiUrl}/clientes/nativos`,
            {
                criteria: {
                    entityName:
                        'Parceiro',

                    compacted:
                        false,

                    ignoreEntityCriteria:
                        false,

                    limit:
                        100,

                    query: {
                        $:
                        termoNormalizado
                    },

                    orderByDesc:
                        false,

                    options: {
                        label:
                            'Parceiro',

                        enableRowsCounter:
                            true,

                        fieldName:
                            'CODPARC',

                        useDescriptionOptions:
                            false
                    },

                    externalCriteria: {
                        query: {},

                        params: {
                            param: []
                        }
                    }
                }
            }
        );
    }

    buscarCotacoesDemonstrativo(): Observable<
        SankhyaEnvelope<DemonstrativoCotacoesResponse>
    > {

        return this.http.post<
            SankhyaEnvelope<DemonstrativoCotacoesResponse>
        >(
            `${this.apiUrl}/cotacoes/dolar`,
            {}
        );
    }

    buscarPrefixosNativosDemonstrativo(
        codparc: string | number
    ): Observable<
        SankhyaEnvelope<DemonstrativoPrefixosResponse>
    > {

        return this.http.post<
            SankhyaEnvelope<DemonstrativoPrefixosResponse>
        >(
            `${this.apiUrl}/prefixos/nativos`,
            {
                CODPARC:
                codparc
            }
        );
    }

    /** pagina = 0 -> ultimos 'limite' cadastros; pagina >= 1 -> lista paginada (tamanho por pagina) com total. */
    listarParceiros(termo: string, limite = 10, pagina = 0, tamanho = 14): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/parceiros/lista`, { termo, limite, pagina, tamanho });
    }

    /** Validar clientes do Aerosys: lista todos os clientes do Aerosys (id, nome, cpfCnpj, status). */
    listarClientesAerosysValidacao(): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/parceiros/validacao-aerosys/ids`, {});
    }

    /** Valida um lote (ate 50) de clientes do Aerosys contra o Sankhya; devolve so os com problema. */
    validarClientesAerosysLote(ids: number[], verificarTipoTelefone = false): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/parceiros/validacao-aerosys/lote`, { ids, verificarTipoTelefone });
    }

    /** Insere no Sankhya o que falta (executar=true) ou apenas simula (executar=false). Ate 15 ids por chamada. */
    /** categorias (opcional): restringe a correção a partes do cadastro; vazio/ausente = tudo. */
    corrigirClientesAerosysLote(ids: number[], executar: boolean, categorias: string[] = []): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/parceiros/validacao-aerosys/corrigir`, { ids, executar, categorias });
    }

    buscarDadosParceiroNativo(
        codparc: string | number
    ): Observable<unknown> {

        return this.http.post(
            `${this.apiUrl}/parceiros/dados-nativo`,
            {
                CODPARC:
                codparc
            }
        );
    }

    alterarClientePrefixoVendaNativo(
        payload: {
            alteracoes: Array<{
                NUNOTA: number;
                CODPARC: number;
                NOMEPARC: string;
                CODAERO: number;
                PREFIXO: string;
            }>;
        }
    ): Observable<
        SankhyaEnvelope<
            DemonstrativoAlteracaoClientePrefixoResponse
        >
    > {

        return this.http.post<
            SankhyaEnvelope<
                DemonstrativoAlteracaoClientePrefixoResponse
            >
        >(
            `${this.apiUrl}/editar-venda/cliente-prefixo`,
            payload
        );
    }

    buscarTiposNegociacaoNativos(
        requestBody: unknown
    ): Observable<unknown> {

        return this.proxy(
            'mge',
            'PesquisaSP.getSuggestion',
            requestBody
        );
    }

    alterarFormaPagamentoVendaNativo(
        payload: {
            alteracoes: Array<{
                NUNOTA: number;
                CODTIPVENDA: number;
                DESCRTIPVENDA: string;
            }>;
        }
    ): Observable<
        DemonstrativoAlteracaoFormaPagamentoResponse
    > {

        return this.http.post<
            DemonstrativoAlteracaoFormaPagamentoResponse
        >(
            `${this.apiUrl}/editar-venda/forma-pagamento`,
            payload
        );
    }

    /*
     * Mantido porque já existia no projeto.
     *
     * Foi renomeado apenas porque TypeScript NÃO permite
     * duas implementações com exatamente o mesmo nome
     * e a mesma assinatura.
     *
     * Este aponta para o endpoint anterior:
     *
     * /editar-venda/ajustes
     */
    buscarAjustesVendaNativoLegado(
        payload: {
            notas: number[];
        }
    ): Observable<
        DemonstrativoAjustesNativosResponse
    > {

        return this.http.post<
            DemonstrativoAjustesNativosResponse
        >(
            `${this.apiUrl}/editar-venda/ajustes`,
            payload
        );
    }

    /*
     * IMPLEMENTAÇÃO ATUAL.
     *
     * DatasetSP.loadRecord
     *     CabecalhoNota / 001
     *
     * DatasetSP.loadRecords
     *     ItemNota / 05Y
     */
    buscarAjustesVendaNativo(
        payload: {
            notas: number[];
        }
    ): Observable<
        DemonstrativoAjustesNativosResponse
    > {

        return this.http.post<
            DemonstrativoAjustesNativosResponse
        >(
            `${this.apiUrl}/editar-venda/ajustes/carregar`,
            payload
        );
    }

    /*
     * CACSP.calculaValoresItemNota
     *
     * Por enquanto utilizamos somente o fluxo
     * capturado e comprovado:
     *
     * CAMPO = PERCDESC
     */
    calcularPercentualAjusteVendaNativo(
        payload: {
            NUNOTA: number;
            SEQUENCIA: number;

            PERCDESC: number;

            VLRANTERIORCAMPO: number;

            /*
             * Neste fluxo representa a cotação da moeda
             * utilizada no cálculo do item.
             */
            VLRMOEDA: number;

            itemNativo:
                Record<string, string>;
        }
    ): Observable<
        DemonstrativoCalculoAjusteNativoResponse
    > {

        return this.http.post<
            DemonstrativoCalculoAjusteNativoResponse
        >(
            `${this.apiUrl}/editar-venda/ajustes/calcular-percentual`,
            payload
        );
    }

    /*
     * CACSP.incluirAlterarItemNota
     *
     * O itemNativo contém o estado completo retornado
     * pelo DatasetSP.loadRecords / ItemNota / 05Y
     * acrescido dos valores retornados por
     * CACSP.calculaValoresItemNota.
     */
    salvarAjustesVendaNativo(
        payload: {
            itens: Array<{
                NUNOTA: number;
                SEQUENCIA: number;

                itemNativo:
                    Record<string, string>;
            }>;
        }
    ): Observable<
        DemonstrativoSalvarAjustesNativosResponse
    > {

        return this.http.post<
            DemonstrativoSalvarAjustesNativosResponse
        >(
            `${this.apiUrl}/editar-venda/ajustes/salvar`,
            payload
        );
    }

    finalizarVendasNativo(
        payload: {
            notas: number[];
        }
    ): Observable<DemonstrativoFinalizacaoVendaResponse> {

        return this.http.post<DemonstrativoFinalizacaoVendaResponse>(
            `${this.apiUrl}/editar-venda/finalizar`,
            payload
        );
    }

    // ####
}

export interface AtividadeAcessoUsuarioMonitorado {
    usuario: string;
    loginEm: string;
    ultimoAcessoEm: string;
    sessoesAbertas: number;
    online: boolean;
}

export interface AtividadeAcessoMonitoramentoResponse {
    acoes?: AtividadeAcessoAcao[];
    fonte: string;
    atualizadoEm: string;
    janelaOnlineMinutos: number;
    totalUsuarios: number;
    totalOnline: number;
    observacao?: string;
    usuarios: AtividadeAcessoUsuarioMonitorado[];
}

export interface AtividadeAcessoAcao {
    usuario: string;
    ocorridoEm: string;
    acao: string;
    status: number;
}
